// @ts-ignore
import i18next from "jsdc-dui/dist/i18n/config";

// 直接添加自訂翻譯資源到已初始化的 i18next 實例
i18next.addResourceBundle(
  "zh-TW",
  "translation",
  {
    menu: {
      // pathColor: "路線顏色",
    },
  },
  true,
  true,
);

i18next.addResourceBundle(
  "en",
  "translation",
  {
    menu: {
      // pathColor: "Route Colors",
    },
  },
  true,
  true,
);
